"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowEquals;
function shallowEquals(a, b) {
  for (var i in a) {
    if (b[i] !== a[i]) return false;
  }

  for (var _i in b) {
    if (b[_i] !== a[_i]) return false;
  }

  return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dist/lib/shallow-equals.js
// module id = ./node_modules/next/dist/lib/shallow-equals.js
// module chunks = 0